(() => {
  const GRAPHQL_QUERY = `
    query GetVariantMapping($retailVariantId: String!) {
      productVariantMappings(first: 1, filter: { retailVariantId: { equals: $retailVariantId } }) {
        edges {
          node {
            id
            retailVariantId
            memberVariantId
          }
        }
      }
    }
  `;

  const mappingCache = new Map();
  const variantCache = new Map();

  function priceStringToCents(value) {
  if (value === null || value === undefined || value === "") return "";
  const num = parseFloat(value);
  if (Number.isNaN(num)) return "";
  return Math.round(num * 100);
}

  function formatMoney(cents) {
    const value = Number(cents || 0);

    if (
      window.Shopify &&
      typeof window.Shopify.formatMoney === "function" &&
      window.Shopify.money_format
    ) {
      return window.Shopify.formatMoney(value, window.Shopify.money_format);
    }

    const currency =
      (window.Shopify &&
        window.Shopify.currency &&
        window.Shopify.currency.active) ||
      "USD";

    return new Intl.NumberFormat(document.documentElement.lang || "en-US", {
      style: "currency",
      currency,
    }).format(value / 100);
  }

  function getMode() {
    return window.Monthlees?.mode === "member" ? "member" : "retail";
  }

  async function fetchVariantMapping(endpoint, retailVariantId) {
    const key = String(retailVariantId || "");
    if (!key) return null;
    if (mappingCache.has(key)) return mappingCache.get(key);

    const promise = fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "omit",
      body: JSON.stringify({
        query: GRAPHQL_QUERY,
        variables: { retailVariantId: key },
      }),
    })
      .then((res) => {
        if (!res.ok) throw new Error(`Mapping request failed: ${res.status}`);
        return res.json();
      })
      .then((json) => json?.data?.productVariantMappings?.edges?.[0]?.node || null)
      .catch((err) => {
        console.warn("Monthlees article CTA mapping lookup failed.", err);
        return null;
      });

    mappingCache.set(key, promise);
    return promise;
  }

  async function fetchVariantJson(variantId) {
    const key = String(variantId || "");
    if (!key) return null;
    if (variantCache.has(key)) return variantCache.get(key);

    const promise = fetch(`/variants/${key}.json`, {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    })
      .then((res) => {
        if (!res.ok) throw new Error(`Variant request failed: ${res.status}`);
        return res.json();
      })
      .then((json) => json?.product_variant || json?.variant || null)
      .catch((err) => {
        console.warn("Monthlees article CTA variant lookup failed.", err);
        return null;
      });

    variantCache.set(key, promise);
    return promise;
  }

  async function hydrateRoot(root) {
    const endpoint = root.dataset.gadgetEndpoint;
    const retailVariantId = root.dataset.retailVariantId;

    if (!endpoint || !retailVariantId) return;

    if (root.dataset.memberVariantId && root.dataset.memberPrice) return;

    const mapping = await fetchVariantMapping(endpoint, retailVariantId);
    if (!mapping?.memberVariantId) return;

    const memberVariant = await fetchVariantJson(mapping.memberVariantId);
    if (!memberVariant) return;

    root.dataset.memberVariantId = String(memberVariant.id);
root.dataset.memberPrice = String(priceStringToCents(memberVariant.price));
root.dataset.memberCompareAtPrice = String(priceStringToCents(memberVariant.compare_at_price));
root.dataset.memberAvailable = "true";
  }

  function updateCta(root) {
    const mode = getMode();

    const retailVariantId = root.dataset.retailVariantId || "";
    const retailPrice = root.dataset.retailPrice || "";
    const retailCompare = root.dataset.retailCompareAtPrice || "";
    const retailAvailable = root.dataset.retailAvailable === "true";

    const memberVariantId = root.dataset.memberVariantId || "";
    const memberPrice = root.dataset.memberPrice || "";
    const memberCompare = root.dataset.memberCompareAtPrice || "";
    const memberAvailable = root.dataset.memberAvailable === "true";

    const memberReady = Boolean(memberVariantId && memberPrice);
    const useMember = mode === "member" && memberReady && memberAvailable;

    const activeVariantId = useMember ? memberVariantId : retailVariantId;
    const activePrice = useMember ? memberPrice : retailPrice;
    const activeCompare = useMember ? memberCompare : retailCompare;
    const activeAvailable = useMember ? memberAvailable : retailAvailable;

    const variantInput = root.querySelector("[data-article-cta-variant-input]");
    const priceEl = root.querySelector("[data-article-cta-price]");
    const compareEl = root.querySelector("[data-article-cta-compare]");
    const button = root.querySelector("[data-article-cta-button]");
    const buttonText = root.querySelector("[data-article-cta-button-text]");
    const badge = root.querySelector("[data-article-cta-badge]");
    const memberBox = root.querySelector("[data-article-cta-member-box]");

    if (variantInput && activeVariantId) {
      variantInput.value = activeVariantId;
    }

    if (priceEl && activePrice) {
      priceEl.textContent = formatMoney(activePrice);
    }

    if (compareEl) {
      const priceNum = Number(activePrice || 0);
      const compareNum = Number(activeCompare || 0);

      if (compareNum > priceNum) {
        compareEl.hidden = false;
        compareEl.textContent = formatMoney(compareNum);
      } else {
        compareEl.hidden = true;
        compareEl.textContent = "";
      }
    }

    if (button) {
      button.disabled = !activeAvailable;
    }

    if (buttonText) {
      buttonText.textContent = activeAvailable ? "Add To Cart" : "Sold out";
    }

    if (badge) {
      badge.textContent = useMember
        ? "Member pricing unlocked"
        : "Member pricing available";
    }

    if (memberBox) {
      memberBox.hidden = useMember;
    }

    root.classList.toggle("is-member-mode", useMember);
  }

  async function refreshRoot(root) {
    await hydrateRoot(root);
    updateCta(root);
  }

  async function refreshAllArticleCtas() {
    const roots = Array.from(document.querySelectorAll("[data-article-product-cta]"));
    if (!roots.length) return;

    await Promise.all(roots.map((root) => refreshRoot(root)));
  }

  function openMembershipModal(root) {
    const detail = {
      source: "article-product-cta",
      productId: root?.dataset.productId || null,
      productHandle: root?.dataset.productHandle || null,
      variantId: root?.dataset.retailVariantId || null,
      memberVariantId: root?.dataset.memberVariantId || null,
    };

    document.dispatchEvent(
      new CustomEvent("monthlees:show-membership-modal", {
        bubbles: true,
        detail,
      })
    );
  }

  function bindMembershipLinks() {
    document.addEventListener("click", (event) => {
      const trigger = event.target.closest("[data-open-membership-modal]");
      if (!trigger) return;

      event.preventDefault();
      const root = trigger.closest("[data-article-product-cta]");
      openMembershipModal(root);
    });
  }

  function bindRefreshEvents() {
    const rerun = () => refreshAllArticleCtas();

    document.addEventListener("monthlees:modeChanged", rerun);
    window.addEventListener("pageshow", rerun);
    window.addEventListener("focus", rerun);

    document.addEventListener("visibilitychange", () => {
      if (!document.hidden) rerun();
    });
  }

  document.addEventListener("DOMContentLoaded", async () => {
    bindMembershipLinks();
    bindRefreshEvents();
    await refreshAllArticleCtas();
  });
})();